import { ChevronDownIcon, ChevronUpIcon } from '@village/icons';
import { Link } from '@village/ui';
import { FC, Fragment, useEffect, createRef, useState } from 'react';

import * as Styled from './styles';

interface Props {
    bio: string;
}

const ProviderBio: FC<Props> = ({ bio }) => {
    const [isExpanded, setIsExpanded] = useState<boolean>(false);
    // TODO: Refactor using VUI component
    const [showToggle, setShowToggle] = useState(false);
    const bioTextRef = createRef<HTMLDivElement>();

    useEffect(() => {
        if (bio && bioTextRef.current) {
            if (bioTextRef.current.scrollHeight > bioTextRef.current.clientHeight) {
                setShowToggle(true);
            }
        }
    }, [bio, bioTextRef]);

    if (!bio) return null;

    const handleClick = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <Fragment>
            <Styled.Bio
                ref={bioTextRef}
                $expanded={isExpanded}
                dangerouslySetInnerHTML={{ __html: bio.replace(/style="(.*?)"/gm, '') }}
            />{' '}
            {/* remove style attribute */}
            {showToggle === true ? (
                <Styled.ExpandToggle>
                    <Link
                        rightIcon={isExpanded ? <ChevronUpIcon size="xs" /> : <ChevronDownIcon size="xs" />}
                        onClick={() => handleClick()}
                    >
                        {isExpanded ? `Show less` : `Show more`}
                    </Link>
                </Styled.ExpandToggle>
            ) : null}
        </Fragment>
    );
};

export { ProviderBio };
